import { render, staticRenderFns } from "./Designers.vue?vue&type=template&id=938d7d70&scoped=true&"
import script from "./Designers.vue?vue&type=script&lang=js&"
export * from "./Designers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938d7d70",
  null
  
)

export default component.exports